import React, { useState } from 'react';
import KervLogo from 'components/atoms/KervLogo/KervLogo';
import { Layout } from 'antd';
import { useAppDispatch, useAppState } from 'context';
import { setSmallScreen } from 'context/actions';
import { classSize } from 'services/constants';
import HeaderIcons from '../HeaderIcons';
import { CreativeType } from 'types/creative';
import { isMobileOnly } from 'react-device-detect';
import { PLAYBACK_TYPE } from 'services/constants';
import './Sidebar.scss';

const { Sider } = Layout;

const Sidebar = (props) =>{
  const { hideInSmallView = false} = props;
  const dispatch = useAppDispatch();
  const [siderWidth, setSiderWidth] = useState(200);
  const { screenSizeClass, creative = {} as CreativeType  } = useAppState();
  const onBreakpoint = (b) => {
    dispatch(setSmallScreen(b ? classSize.sm : classSize.lg))
    setSiderWidth(b ? 55 : 200);
  }
  const isCtv = creative.playback_id === PLAYBACK_TYPE.ctv;
  const isSocial = creative.playback_id === PLAYBACK_TYPE.social;
  const dynamicProps = {}

  // for now hide all menus on mobile phones
  if( isMobileOnly || (screenSizeClass === classSize.sm && (isCtv || isSocial || hideInSmallView ))) {
    dynamicProps['trigger'] = null;
  }

  return (
    <Sider className={`app-container__sidebar ${screenSizeClass}`} width={siderWidth} collapsedWidth={0} breakpoint={"lg"} onBreakpoint={onBreakpoint} {...dynamicProps}>
      <div className='sidebar-content'>
        {screenSizeClass === classSize.lg && <KervLogo /> }
        {screenSizeClass === classSize.sm && <HeaderIcons vertical={true} />}
      </div>
    </Sider>
  );
}

export default Sidebar;
